export default {
  setFavoriteVendors: (state, data) => {
    state.favoriteVendors = data;
  },
  setFavoriteProducts: (state, data) => {
    state.favoriteProducts = data;
  },
};
